import React, { useEffect, createElement } from 'react';
export function GoogleAnalytics() {
  useEffect(() => {
    // Only run this code in the browser and after initial render
    if (typeof window !== 'undefined') {
      // Use requestIdleCallback for non-critical operations
      const initAnalytics = () => {
        // Create a single script element for better performance
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.innerHTML = `
          // Load the gtag script dynamically
          const gtagScript = document.createElement('script');
          gtagScript.async = true;
          gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-LN1YYQ0BV0';
          document.head.appendChild(gtagScript);
          // Initialize gtag
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-LN1YYQ0BV0', { 'send_page_view': false });
          // Delay page view to not impact LCP
          setTimeout(() => {
            gtag('event', 'page_view');
          }, 3000);
        `;
        // Append script to body for better performance
        document.body.appendChild(script);
      };
      // Use requestIdleCallback if available, otherwise setTimeout
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(initAnalytics, {
          timeout: 5000
        });
      } else {
        setTimeout(initAnalytics, 3000); // Delay by 3 seconds as fallback
      }
    }
  }, []);
  return null;
}
export default {
  GoogleAnalytics
};